import { createFileRoute } from "@tanstack/react-router";

import ChallengeTools from "@/components/ChallengeTools";

const Component = () => {
  const { challengeUuid } = Route.useParams();
  return ChallengeTools({ challengeUuid });
};

export const Route = createFileRoute("/gym/$venueUuid/challenges/$challengeUuid/tools")({
  component: Component,
});
